<template>
    <div>
        <a-card size="small" title="在线设备v5">
        </a-card>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="templeteTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'

export default {
    data() {
        return {
            channelcode:'',
            searchP:{
                keyword:'',
                passwaytype:'',
                channelcode:'',
            }
        };
    },
    methods: {

        handleSubmit(searchP){
            this.searchP = searchP;
            searchP.channelcode = this.channelcode;
            this.$refs.templeteTableID.handleSearch(this.searchP);
        },

    },
    components:{
        tableE,
        searchE,
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
